export default __webpack_public_path__ + "static/media/IMG-20240708-WA0010.95fc7a64.jpg";